import * as React from 'react';
import { ButtonRegular, ButtonRegularProps } from '../Button/ButtonRegular';
import styles from './DotButton.module.scss';

export type DotButtonProps = ButtonRegularProps & {
	readonly selected?: boolean;
	readonly index: number;
	readonly label?: string;
};

export const DotButton: React.FC<DotButtonProps> = ({ selected, index, onClick, label = 'Slide' }) => {
	return (
		<ButtonRegular
			className={styles.button}
			aria-label={`${label} ${index}`}
			aria-current={selected}
			onClick={onClick}
			hasNoStyles
		/>
	);
};
